import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./NavBar.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FaHome } from "react-icons/fa";
import logodark from "../images/Dataharbor-dark.png";
import "bootstrap/dist/css/bootstrap.min.css";

const NavBar = () => {
  const [click] = useState(false);
  const [show, setShow] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const showDropdown = () => {
    if (!isMobile) setShow(true);
  };

  const hideDropdown = () => {
    if (!isMobile) setShow(false);
  };

  const toggleDropdownMobile = (e) => {
    if (isMobile) {
      e.preventDefault();
      setShow((prev) => !prev);
    }
  };

  const handleNavbarToggle = (isOpen) => {
    if (!isOpen) {
      setShow(false);
    }
  };

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 992);
    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  return (
    <Navbar
      collapseOnSelect
      className="header"
      fixed="top"
      expand="lg"
      onToggle={handleNavbarToggle}
      style={{
        backgroundColor: "var(--background1)",
        position: "fixed",
        zIndex: 1,
        width: "100%",
        transition: "background-color 0.5s ease-in-out",
      }}
    >
      <Container>
        <Navbar.Brand href="/">
          <div
            className="logo-light"
            style={{
              backgroundSize: "100% 100%",
              backgroundImage: `url(${logodark})`,
            }}
            alt="DataHarbor Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav
            key={currentPath}
            className={click ? "nav-menu active" : "nav-menu"}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              backgroundColor: "var(--background1)",
              display: "flex",
              alignItems: "center",
              transition: "background-color 0.5s ease-in-out",
            }}
          >
            <Nav.Link
              href="/"
              className={`nav-link-custom home-icon-link nav-item-animated ${
                currentPath === "/" ? "hidden-home" : ""
              }`}
            >
              <FaHome size={20} title="Go to Home" />
            </Nav.Link>

            <Nav.Link href="/products" className="nav-link-custom nav-item-animated">
              Products
            </Nav.Link>

            <Nav.Link href="/services" className="nav-link-custom nav-item-animated">
              Services
            </Nav.Link>

            <Nav.Link href="/contact" className="nav-link-custom nav-item-animated">
              Contact Us
            </Nav.Link>

            <NavDropdown
              title={<span className="nav-link-custom">About Us</span>}
              id="collapsible-nav-dropdown"
              className="nav-item-animated"
              show={show}
              onMouseEnter={isMobile ? undefined : showDropdown}
              onMouseLeave={isMobile ? undefined : hideDropdown}
              onClick={toggleDropdownMobile}
              style={{ position: isMobile ? "static" : "relative" }}
            >
              <NavDropdown.Item href="/about" className="nav-link-custom">
                About DataHarbor
              </NavDropdown.Item>
              <NavDropdown.Item href="/ourteam" className="nav-link-custom">
                Our Team
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;